export default (state = { products: [] }, action) => {
  switch (action.type) {
    case 'FETCH_PRODUCT_RECOMENDATION':
      return { ...state }
    case 'FETCH_PRODUCT_RECOMENDATION_SUCCESS':
      return { ...state, ...action.payload.data }
    case 'FETCH_PRODUCT_RECOMENDATION_FAIL':
      return { ...state, error: action.error }
    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY':
      return { ...state }
    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY_SUCCESS':
      const availability = action.payload.data[0]

      const { products } = state
      const {
        meta: {
          previousAction: { sku }
        }
      } = action

      const index = products.findIndex(p => p.sku === sku)

      if (products[index]) {
        products[index].availability = { ...availability }
      }

      products.forEach(item => {
        item.availability['onlyCash']['sellingPrice'] = 120
      })

      return { ...state, products }
    case 'FETCH_RECOMENDATION_CARD_AVAILABILITY_FAIL':
      return { ...state, error_availability: action.error }
    default:
      return { ...state }
  }
}

const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const Products = productSuggestion => {
  const { products } = productSuggestion

  products.forEach(item => {
    if (item.availability) {
      item.availability['onlyCash'] = {
        sellingPrice: getRandomInt(0, 1200).toFixed(2)
      }
    }
  })

  const voucher = {
    products: products || [],
    title: 'Produtos recomendados',
    titleMobile: 'Produtos'
  }

  return voucher
}



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductRecomendation/reducer.js